import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function ServiceOutcomes() {
  const outcomes = [{
    title: 'Consistent AI context skills',
    description: 'your team knows how to give AI the right inputs to get reliable, high-quality outputs.'
  }, {
    title: 'Validated workflows',
    description: 'a set of AI-assisted processes the team has tested and refined against their actual work.'
  }, {
    title: 'A shared learning system',
    description: 'a way to keep sharing discoveries and adapting as AI tools evolve.'
  }, {
    title: "Clear judgment on when AI helps and when it doesn't",
    description: 'so your team stops wasting time on the wrong tasks.'
  }];
  return <section className="w-full bg-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-293" data-mp="3lmudryq91w1s">
      <div className="max-w-4xl mx-auto" data-id="element-294" data-mp="3loyrt9hv4bfs">
        <div className="bg-brand-light-gray p-10 md:p-16 rounded-lg shadow-sm border border-gray-100" data-id="element-295" data-mp="3qlfgq5wvyttx">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-10" data-id="element-296" data-mp="26np7s54fu1qo">
            What your team walks away with
          </h2>

          <ul className="space-y-8 mb-12" data-id="element-297" data-mp="21uw3tjgsmxfn">
            {outcomes.map((outcome, index) => <li key={index} className="flex items-start" data-id="element-298" data-mp="1wxvyjarrpypl" data-mpi={index}>
                <CheckCircle2Icon className="w-8 h-8 text-brand-orange mr-6 flex-shrink-0 mt-1" data-id="element-299" data-mp="1swapk0icu4ko" />
                <p className="text-xl text-brand-gray leading-relaxed" data-id="element-300" data-mp="2pmjovkrdjea0">
                  <strong className="text-brand-navy font-bold" data-id="element-301" data-mp="2pjnprt3sijjz">
                    {outcome.title}:
                  </strong>{' '}
                  {outcome.description}
                </p>
              </li>)}
          </ul>

          <div className="pt-10 border-t border-gray-200" data-id="element-302" data-mp="2bl7ahdrv3kq8">
            <p className="text-brand-gray-light text-lg italic" data-id="element-303" data-mp="1566o9zsn2gwu">
              None of this is tied to a specific tool or model. These are the
              fundamentals of how your team works with AI, and they hold up no
              matter what changes next.
            </p>
          </div>
        </div>
      </div>
    </section>;
}